import React, { useContext, useEffect, useState } from 'react';
import "../Styles/UploadStudyCss.css";
import userContext from '../../../../context/users/UserContext';
import { BORDER, SELECTED_TAB_KEY, USERTYPES } from '../../../../constants/Constants';
import { useTranslation } from 'react-i18next';
import { FileUploader } from 'react-drag-drop-files';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { Tab, TabList } from '@fluentui/react-tabs';
import UploadStudyTab from './UploadStudyTab';
import { tabDetails } from './helper/helper';
import { DatePicker, TextField, defaultDatePickerStrings, mergeStyles } from '@fluentui/react';
import loaderContext from '../../../../context/loader/LoaderContext';
import { StudyUploadSchema } from './StudyUploadSchema';
import Moment from "moment";
import studylistContext from '../../../../context/studylist/StudylistContext';
import ProgressBarContext from '../../../../context/progressbar/ProgressBarContext';
import ProgressBar from '../ProgressBar';
import Select from "react-select";
import CustomSelect from '../../../../components/CustomSelect';
import themeContext from '../../../../context/theme/ThemeContext';
import { getUploadStudyClients, getUploadStudyInitialData } from '../../../../service/StudyListService';

const UploadStudyBody = (props) => {
  const { minimalClientFirmList } = useContext(studylistContext);
    let enterprise = (process.env.REACT_APP_ENTERPRISE_PLATFORM=="true"||process.env.REACT_APP_ENTERPRISE_PLATFORM==true)?true:false;
    const {roles, firmId, firmName } = useContext(userContext);
    const [t]  = useTranslation();
    const fileTypes = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/octet-stream", "text/plain", "application/msword", "DCM", "zip"];
    const imageFileTypes = ["JPEG", "PNG", "JPG"];
    const [selectedValue, setSelectedValue] = useState(
      SELECTED_TAB_KEY.UPLOADSTUDY + "1"
    );
    const { getThemeColor ,themeName,getScrollBarStyleForTheme} = useContext(themeContext);
    const {ref, setLoaderRunning} = useContext(loaderContext);
    const [loadingState, setLoadingState] = useState("");
    const [loading, setLoading] = useState(false);
    
    const [modalityList, setModalityList] = useState([]);
    const today = new Date();
    const defaultSelectedModality = 'CR';
    const {progressObjs} = useContext(ProgressBarContext);
    const [isDropDownMandatory, setIsDropDownMandatory] = useState(false);
    const [dropDownOptionsState, setDropDownOptionsState] = useState([]);
    const [showDicomClientOption, setShowDicomClientOption] = useState(false);
    const [showJpgClientOption, setShowJpgClientOption] = useState(false);

    const requiredAsteriskClass = mergeStyles({
      color: 'red',
    });
    const [clientOptions, setClientOptions] = useState([]);
    const [jpgClientOptions, setJpgClientOptions] = useState([]);
    const [firmOption, setFirmOptions] = useState([]);

    const formatDate = (date) => {
      var currentDate = Moment(date).local().format("DD-MMM-YYYY");
      return date == "" ? "" : currentDate;
    };

    useEffect(() => {
      async function fetchData() {
        const response =  await getUploadStudyInitialData();
        console.log(response);
        setDropDownOptionsState(response.data.data.minimalClientFirmList);  
      }
      fetchData();
      // setDropDownOptionsState(minimalClientFirmList);
    }, []);

    useEffect(() => {
      if(dropDownOptionsState.length > 0){
        let clientOptionsTemp = dropDownOptionsState
        ? dropDownOptionsState
            .filter(item => item.id >= 0) 
            .map((item) => ({
              value: item.id,
              label: item.name,
            }))
        : null;
      
        // if (clientOptionsTemp !== null) {
        //   clientOptionsTemp.unshift({ value: -1, label: "Select" });
        // }
       
        if(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST){
            if(clientOptionsTemp.length === 1){
              let item = {
                value :  clientOptionsTemp[0].value,
                firstCall : true
              }
              props.setFilterObj((prevFilterObj) => {
                const newItem = {...prevFilterObj};
                newItem.firmId = item.value;
                return newItem;
              });
              handleDicomFirmChange(item);
              handleJpgFirmChange(item);
              props.setFilterObj((prevFilterObj) => {
                const newItem = {...prevFilterObj};
                newItem.firmId = clientOptionsTemp[0].value;
                newItem.jpgFirmId = clientOptionsTemp[0].value;
                return newItem;
              })
            }
            setFirmOptions(clientOptionsTemp);
        }
        else{
          setClientOptions(clientOptionsTemp);
          setJpgClientOptions(clientOptionsTemp);
          setShowJpgClientOption(true);
          setShowDicomClientOption(true);
          if(clientOptionsTemp.length === 1){
            props.setFilterObj(() => {
              const newItem = {...props.filterObj};
              newItem.minimalClientId = clientOptionsTemp[0].value;
              newItem.jpgMinimalClientId = clientOptionsTemp[0].value;
              return newItem;
            })
          }
        }
      }else if(minimalClientFirmList.length == 0 && roles[0] == USERTYPES.RADIOLOGIST){
        props.setConfirmModalMessage(t("upload-study.upload-not-allowed"));
        props.setShowConfirmModal(true);
      }
    }, [dropDownOptionsState]);
  
  

    const dropDownStyle = {
        dropdownItem: {
          fontSize: "14px",
          lineHeight: "18px",
          backgroundColor:"#070707",
          color: "white",
          borderRadius: "8px"
        },
        dropdownItemSelected: {
          fontSize: "14px",
          lineHeight: "18px",
        },
        dropdownItemsWrapper : {
          maxHeight: "300px"
        },
        label: {
          color: "white", 
        }
      };

      const onTabSelect = (event, data) => {
        let currentTab = data.value;
        if(selectedValue == SELECTED_TAB_KEY.UPLOADSTUDY + "1" ){
          props.setIsJpg(true);
        }else{
          props.setIsJpg(false);
        }
        console.log("currentTab->", currentTab);
        document.getElementById(currentTab).style.border = getThemeColor("border");
        document.getElementById(currentTab).style.borderBottom = "unset";
        document.getElementById(currentTab).style.borderRadius =
          "10px 10px 0px 0px";
        const tabDetail = tabDetails(selectedValue);
        for (let i = 1; i <= tabDetail.length; i++) {
          if (currentTab.charAt(currentTab.length - 1) != i) {
            document.getElementById(
              SELECTED_TAB_KEY.UPLOADSTUDY + `${i}`
            ).style.border = "";
            document.getElementById(
              SELECTED_TAB_KEY.UPLOADSTUDY + `${i}`
            ).style.borderRadius = "";
            document.getElementById(
              SELECTED_TAB_KEY.UPLOADSTUDY + `${i}`
            ).style.borderBottom = "";
          }
        }
        setSelectedValue(data.value);
        
      };

      const setSexFunction = (event, selected) => {
        console.log(selected)
          props.setFilterObj(() => {
            const newItem = {...props.filterObj};
            newItem.sex = selected.key;
            return newItem;
          })
      };

      const dateOfBirthFunction = (event) => {
        console.log(event);
        props.setFilterObj({ ...props.filterObj, dob: event });
      };

      const modalityFunction = (event, selected) => {
        var modId = selected.key;
        console.log(selected)
          props.setFilterObj(() => {
            const newItem = {...props.filterObj};
            newItem.modality = modId;
            return newItem;
          })
        };

      const clientFunction = (event, selected) => {
        var minimalClientId = selected.key;
        props.setFilterObj(() => {
          const newItem = {...props.filterObj};
          newItem.minimalClientId = minimalClientId;
          return newItem;
        })
      };

      const handleClientChange = (item) => {
        props.setFilterObj(() => {
          const newItem = {...props.filterObj};
          newItem.minimalClientId = item.value;
          return newItem;
        })
      };

      const handleJpgClientChange = (item) => {
        props.setFilterObj((prevFilterObj) => {
          const newItem = {...prevFilterObj};
          newItem.jpgMinimalClientId = item.value;
          return newItem;
        })
      };

      
      const handleDicomFirmChange = async (item) => {
        props.setFilterObj((prevFilterObj) => {
          const newItem = {...prevFilterObj};
          newItem.firmId = item.value;
          return newItem;
        });
        
        let response = await getUploadStudyClients(item.value);
        if (response.status == 200 && response.data.result == "SUCCESS") {
          let clientList = response.data.data;
          let clientOptionsTemp = clientList
            ?  clientList
                .map((item) => ({
                  value: item.id,
                  label: item.name,
                }))
            : null;

            // if (clientOptionsTemp !== null) {
            //   clientOptionsTemp.unshift({ value: -1, label: "Select" });
            // }
            props.setFilterObj((prevFilterObj) => {
              const newItem = {...prevFilterObj};
              newItem.firmId = item.value;
              if(clientOptionsTemp.length == 1)
                newItem.minimalClientId = clientOptionsTemp[0].value;
              else
                newItem.minimalClientId = -1;

              if(item.firstCall)
                newItem.jpgFirmId = item.value;
              return newItem;
            });

            setClientOptions(clientOptionsTemp);
          
          if(clientOptionsTemp.length > 0)
            setShowDicomClientOption(true);
          else
            setShowDicomClientOption(false);
        }
      };

      const handleJpgFirmChange = async (item) => {
        props.setFilterObj(() => {
          const newItem = {...props.filterObj};
          newItem.jpgFirmId = item.value;
          return newItem;
        });
        
        let response = await getUploadStudyClients(item.value);
        if (response.status == 200 && response.data.result == "SUCCESS") {
          let clientList = response.data.data;
          let clientOptionsTemp = clientList
            ?  clientList
                .map((item) => ({
                  value: item.id,
                  label: item.name,
                }))
            : null;

            // if (clientOptionsTemp !== null) {
            //   clientOptionsTemp.unshift({ value: -1, label: "Select" });
            // }
            props.setFilterObj((prevFilterObj) => {
              const newItem = {...prevFilterObj};
              newItem.jpgFirmId = item.value;
              if(clientOptionsTemp.length == 1)
                newItem.jpgMinimalClientId = clientOptionsTemp[0].value;
              else
                newItem.jpgMinimalClientId = -1;

              if(item.firstCall)
                newItem.firmId = item.value;
              return newItem;
            });

            setJpgClientOptions(clientOptionsTemp);
          
          if(clientOptionsTemp.length > 0)
            setShowJpgClientOption(true);
          else
            setShowJpgClientOption(false);
        }
      };

      const handleSelectFileClick = () => {
        document.getElementById('fileInput')?.click();
      };
      const handleJpgUploadChange = (files) => {
        if (files.length > 0) {
          props.setSelectedFileName(files[0].name);
        } else {
          props.setSelectedFileName(t("upload-study.no-file-selected"));
        }
        props.setIsJpg(true);
        props.setFilterObj(() => {
          const newItem = {...props.filterObj};
          newItem.files = files;
          return newItem;
        })
        props.setshowJpgErrorMessage(false);
      }

      useEffect(() => {
        if (
          document.getElementById(SELECTED_TAB_KEY.UPLOADSTUDY + "1") != null
        ) {
          document.getElementById(
            SELECTED_TAB_KEY.UPLOADSTUDY + "1"
          ).style.border = getThemeColor("border");
          document.getElementById(
            SELECTED_TAB_KEY.UPLOADSTUDY + "1"
          ).style.borderBottom = "unset";
          document.getElementById(
            SELECTED_TAB_KEY.UPLOADSTUDY + "1"
          ).style.borderRadius = "10px 10px 0px 0px";
        }
      }, [document.getElementById(SELECTED_TAB_KEY.UPLOADSTUDY + "1")]);
      
      const handleFileChange = (files) => {
        if(selectedValue == SELECTED_TAB_KEY.UPLOADSTUDY + "1"){
          console.log("-----handle file change-----------")
          props.handleFileUploadChange(files);
        }
      }

      const handleAccessionNumberChange = (event) => {
        const { name, value } = event.target;
        const numericValue = value.replace(/[^a-zA-Z0-9]/g, '');
        props.setValues((prevValues) => ({
          ...prevValues,
          accessionNumber: numericValue,
        }));
      };


      // const getDropDownLabel = () => {
      //   if(roles[0] == USERTYPES.ADMIN){
      //     return t("upload-study.firm");
      //   } else{
      //     return t("upload-study.client");
      //   }
      // };

      const getDropDownPlaceHolder = () => {
        if(roles[0] == USERTYPES.ADMIN){
          return t("upload-study.select-firm");
        } else{
          return t("upload-study.select-client");
        }
      };

      const sexOptions = [
        { key: 'M', text: t("patient.male") },
        { key: 'F', text: t("patient.female") },
        { key: 'O', text: t("patient.other") },
      ];  

  return (
    <div ref={props.divRef} className="upload-study-modal-container upload-study-body" style={{colorScheme:`${themeName==='light'?"none":"inherit"}`}}>
          {false ? //!(roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) ?
            <div className='container-content'>
                {enterprise && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR) ?
                    <div className='hosp-div'>
                        <label className='label'>{t("upload-study.choose-hosp")}</label>
                        <Dropdown
                        styles={dropDownStyle}
                        options ={props.hospOrFirmList}             
                        onChange={ props.handleHospital } 
                        className="firm-dropdown"
                        />    
                    </div> 
                    : roles[0] == USERTYPES.ADMIN ? 
                        <div className='hosp-div'>
                            <label className='label'>{t("upload-study.choose-firm")}</label>
                            <Dropdown
                            styles={dropDownStyle}
                            options ={props.hospOrFirmList}             
                            onChange={ props.handleHospital } 
                            className="firm-dropdown"
                            />  
                        </div> : null
                }
                <div className='upload-study'>
                {!props.isUploadAllowed && <div style={{color: "red", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>{props.errorMessage}</div>}
                    <FileUploader handleChange={props.handleFileUploadChange} name="files" types={fileTypes} classes="label-class"
                    label="Drag your file(s) here or browse" multiple={true} children={<p className='fileUploader' style={{color:getThemeColor("primary-color")}}>
                      {t("upload-study.drag-drop-files")}</p>}
                    />
                    
                </div>
                <div className='studyFileNamesContainer common-modal-scroll'>
                {/* {props.uploadFiles.map((file, index) => (
                      <div key={index}>{file}</div>
                  ))} */}
                  {progressObjs.map((progressObj, index) => (
                      !progressObj.isJpg && (
                      <div key={index} className="fileNamesContent">
                        <ProgressBar
                          progressBarId={index}
                          setSelectedFileName={progressObj.setSelectedFileName}
                          setValues={progressObj.setValues}
                          formData={progressObj.formData}
                          height={progressObj.height}
                          fileName={progressObj.fileName}
                          isZip={progressObj.isZip}
                          isJpg = {progressObj.isJpg}
                          divRef = {props.divRef}
                        />
                      </div>)
                      ))}
                </div>
            </div>
            : 
            <div>
              {<UploadStudyTabSection
                onTabSelect={onTabSelect}
                selectedValue={selectedValue}
                tabDetails={tabDetails}
              />}
               <div
                style={{
                  borderBottom: getThemeColor("border"),
                  width: "100%",
                  boxSizing: "border-box",
                }}
              ></div>
               {(selectedValue == SELECTED_TAB_KEY.UPLOADSTUDY + "1") 
                    && <UploadOnlyDicom 
                    hospOrFirmList = {props.hospOrFirmList}
                    handleHospital = {props.handleHospital}
                    isUploadAllowed= {props.isUploadAllowed}
                    errorMessage= {props.errorMessage}
                    handleFileChange= {handleFileChange}
                    uploadFiles= {props.uploadFiles} 
                    fileTypes = {fileTypes}
                    clientOptions = {clientOptions}
                    handleClientChange = {handleClientChange}
                    handleDicomFirmChange = {handleDicomFirmChange}
                    filterObj = {props.filterObj}
                    getDropDownPlaceHolder = {getDropDownPlaceHolder}
                    firmOption = {firmOption}
                    showDicomClientOption = {showDicomClientOption}
                    dicomClientDropDownError = {props.dicomClientDropDownError}
                    dicomFirmDropDownError = {props.dicomFirmDropDownError}
                    showDicomErrorMessage = {props.showDicomErrorMessage}
                    dicomErrorMessage = {props.dicomErrorMessage}
                    />}
              {(selectedValue == SELECTED_TAB_KEY.UPLOADSTUDY + "2") && (
                <div className='container-content'>
                   <div className='edit-patient-modal-container'>
                    <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                            <TextField
                              className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12 upload-study-placeholder" 
                              name="patientName"
                              placeholder={t("patient.name")}
                              onChange={props.handleChange}
                              value={props.values.patientName}
                              errorMessage={props.errors.patientName}
                              label={(
                                <span>
                                  {t("patient.name")}<span style={{ marginLeft: "4px", color: 'red' }}>*</span>
                                </span>
                              )}
                              // onKeyDown={handleEnterKeyPress}
                              // required
                            />
                            
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                                <TextField 
                                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 upload-study-placeholder"
                                  value={props.values.patientId} 
                                  name="patientId" 
                                  onChange={props.handleChange}
                                  placeholder={t("patient.id")}
                                  errorMessage={props.errors.patientId}
                                  label={(
                                    <span>
                                      {t("patient.id")}<span style={{ marginLeft: "4px", color: 'red' }}>*</span>
                                    </span>
                                  )}
                                  // onKeyDown={handleEnterKeyPress}
                                  // required
                                />
                            <div></div>
                                <Dropdown
                                    options={ sexOptions } 
                                    // value={props.filterObj.sex}
                                    // defaultValue={props.filterObj.sex != undefined
                                    //   ? sexOptions.find(option => option.key === props.filterObj.sex)
                                    //   : sexOptions.find(option => option.key === 'M')}
                                    value={props.filterObj.sex != undefined
                                      ? sexOptions.find(option => option.key === props.filterObj.sex)
                                      : sexOptions.find(option => option.key === 'M')}
                                    placeholder={t("patient.placeholder.sex")}
                                    onChange={ setSexFunction } 
                                    errorMessage={props.errors.sex}
                                    className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                                    label={t("patient.sex")}
                                />
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                                <TextField 
                                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 upload-study-placeholder" 
                                  value={props.values.age} 
                                  name="age" 
                                  onChange={props.handleChange} 
                                  placeholder= {t("patient.placeholder.age")}
                                  errorMessage={props.errors.age}
                                  // onKeyDown={handleEnterKeyPress}
                                  label={t("patient.age")}
                                />
                                <div></div>
                                <DatePicker
                                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                                  value={props.filterObj.dob}
                                  errorMessage={props.errors.dob}
                                  name="dob"
                                  onSelectDate={dateOfBirthFunction}
                                  strings={defaultDatePickerStrings}
                                  placeholder={t("patient.placeholder.dob")}
                                  maxDate={today}
                                  label={t("patient.dob")}
                                  formatDate={(date) => {
                                    const day = date.getDate().toString().padStart(2, '0');
                                    const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
                                    const year = date.getFullYear();
                                    return `${day}-${month}-${year}`;
                                  }}
                                />
                                
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                            <Dropdown
                                styles={dropDownStyle}
                                value={props.filterObj.modality}
                                options={ 
                                  [ 
                                    { key: 'CR', text: 'CR' }
                                  ] 
                                } 
                                defaultSelectedKey={defaultSelectedModality}
                                onChange={modalityFunction} 
                                // defaultSelectedKeys={editPatientModality}
                                className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                                label={(
                                  <span style={{color: getThemeColor("primary-color")}}>
                                    {t("patient.mod")}<span style={{ marginLeft: "4px", color: 'red' }}>*</span>
                                  </span>
                                )}
                                // required
                                // disabled
                            />
                            <div></div>
                            <TextField 
                                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6 upload-study-placeholder" 
                                  value={props.values.accessionNumber} 
                                  errorMessage={props.errors.accessionNumber}
                                  name="accessionNumber" 
                                  onChange={handleAccessionNumberChange} 
                                  placeholder= {t("patient.placeholder.accessionNum")}
                                  label={t("patient.accessionNum")}
                              />
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                          <hr></hr>
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
                          {/* <Dropdown
                            styles={dropDownStyle}
                            defaultSelectedKey={ props.filterObj.minimalClientId }
                            onChange={clientFunction} 
                            options={clientOptions}
                            // defaultSelectedKeys={editPatientModality}
                            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                            label={t("upload-study.client")}
                            placeholder={t("upload-study.select-client")}                          
                            /> */}
                            {(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST ) && 
                              <div style={{marginBottom:"20px"}}>
                                  <div style={{color: getThemeColor("primary-color")}} className="upload-study-body-label">{t("upload-study.firm")}<span style={{ marginLeft: "4px", color: 'red' }}>*</span></div>
                                  <CustomSelect
                                    options={firmOption}
                                    defaultValue={
                                      props.filterObj.jpgFirmId
                                      ? firmOption.find(option => option.value === props.filterObj.jpgFirmId)
                                      :  firmOption.length == 0 ? firmOption[0] : -1}
                                    value={
                                      props.filterObj.jpgFirmId
                                      ? firmOption.find(option => option.value === props.filterObj.jpgFirmId)
                                      : firmOption.length == 0 ? firmOption[0] : -1}

                                    label={t("upload-study.firm")}
                                    placeholder={t("upload-study.select-firm")} 
                                    maxHeight="30px"
                                    errorState={props.errorState}
                                    onChange={(item) => {
                                      handleJpgFirmChange(item);
                                    }}
                                    zIndex = {1000}
                                  />
                                  <div style={{ marginLeft:"10px", marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>
                                      {props.jpgFirmDropDownError}
                                  </div>
                                </div>
                              }

                          {showJpgClientOption && <div>
                              <div style={{color: getThemeColor("primary-color")}} className="upload-study-body-label">{t("upload-study.client")}
                                {!(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && <span style={{ marginLeft: "4px", color: 'red' }}>*</span>}
                              </div>
                              <CustomSelect
                                options={jpgClientOptions}
                                defaultValue={
                                  props.filterObj.jpgMinimalClientId
                                  ? jpgClientOptions.find(option => option.value === props.filterObj.jpgMinimalClientId)
                                  : jpgClientOptions.length == 0 ? jpgClientOptions[0] : -1}
                                value={
                                  props.filterObj.jpgMinimalClientId
                                  ? jpgClientOptions.find(option => option.value === props.filterObj.jpgMinimalClientId)
                                  : jpgClientOptions.length == 0 ? jpgClientOptions[0] : -1}
                                // label={t("upload-study.client")}
                                label={t("upload-study.client")}
                                // placeholder={t("upload-study.select-client")}  
                                placeholder={getDropDownPlaceHolder()}
                                errorState={props.errorState}
                                maxHeight="30px"
                                onChange={(item) => {
                                  handleJpgClientChange(item);
                                }}
                                zIndex = {999}
                              />
                               <div style={{ marginLeft:"10px", marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>
                                {props.jpgClientDropDownError}
                              </div>
                            </div>}
                        </div>
                        <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                        <div className='form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12'>
                            <FileUploader 
                              style={{ paddingLeft: "8px",paddingRight: "8px" }}
                              handleChange={handleJpgUploadChange} 
                              name="files" 
                              types={imageFileTypes} 
                              classes="label-class"
                              multiple={true} 
                              children={
                                <div style={{color: getThemeColor("primary-color")}} className='fileUploader-jpg'>
                                    <p>{t("upload-study.upload-jpg")}
                                      <button style={{ marginLeft: "10px" }} onClick={handleSelectFileClick}>Select File</button>
                                    </p>
                                    <div>
                                      {props.selectedFileName && <span style={{ marginLeft: "10px" }}>{props.selectedFileName}</span>}
                                    </div>
                                </div>}
                              id="fileInput"
                            />
                           {props.showJpgErrorMessage && <div style={{ marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>{props.jpgErrorMessage}</div>}
                          </div>
                        </div>
                        <div className='studyFileNamesContainer common-modal-scroll'>
                          {/* {props.uploadJpgFiles.map((file, index) => (
                                <div key={index}>{file}</div>
                            ))} */}
                            {progressObjs.map((progressObj, index) => (
                              progressObj.isJpg && (
                              <div key={index} className="fileNamesContent">
                                <ProgressBar
                                  progressBarId={index}
                                  setSelectedFileName={progressObj.setSelectedFileName}
                                  setValues={progressObj.setValues}
                                  formData={progressObj.formData}
                                  height={progressObj.height}
                                  fileName={progressObj.fileName}
                                  isZip={progressObj.isZip}
                                  setFilterObj={progressObj.setFilterObj}
                                  isJpg = {progressObj.isJpg}
                                  divRef = {progressObj.divRef}
                                />
                              </div>)
                            ))}
                        </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          }
    </div>
  )
}

export default UploadStudyBody


const UploadStudyTabSection = ({ onTabSelect, selectedValue, tabDetails }) => {

  const getTabActiveStatus = (tabId) =>{
    if(selectedValue === tabId) return true;
    return false;
  }

  return (
    <TabList
      style={{ marginLeft: "10px" }}
      className="tab-list-container-cmp tabList"
      defaultSelectedValue={SELECTED_TAB_KEY.UPLOADSTUDY+"1"}
      selectedValue={selectedValue}
      onTabSelect={onTabSelect}
    >
      {tabDetails(selectedValue).map((tabElement, index) => {
        return (
          <Tab
            key={index}
            className="top-tab-cmp"
            id={SELECTED_TAB_KEY.UPLOADSTUDY + (index + 1).toString()}
            value={SELECTED_TAB_KEY.UPLOADSTUDY + (index + 1).toString()}
          >
            {
              <UploadStudyTab
                title={tabElement.title}
                contentClass={tabElement.contentClass}
                active={getTabActiveStatus(tabElement.id)}
              />
            }
          </Tab>
        );
      })}
    </TabList>
  );
};

const UploadOnlyDicom = (props) =>{
  let enterprise = (process.env.REACT_APP_ENTERPRISE_PLATFORM=="true"||process.env.REACT_APP_ENTERPRISE_PLATFORM==true)?true:false;
  const {roles } = useContext(userContext);
  const [t]  = useTranslation();
  const [uploadFiles,setUploadFiles] = useState([]);
   const {progressObjs} = useContext(ProgressBarContext);
  const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
  useEffect(() => {
    if(uploadFiles.length > 0){
      props.handleFileChange(uploadFiles);
    }
  },[uploadFiles]);

  const handleUploadFile = (files) =>{
    setUploadFiles(files);
  };
  return (
    <div className='container-content'>
      {(enterprise && (roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR)) &&
          <div className='hosp-div'>
              <label className='label'>{t("upload-study.choose-hosp")}</label>
              <Dropdown
              // styles={dropDownStyle}
              options ={props.hospOrFirmList}             
              onChange={ props.handleHospital } 
              className="firm-dropdown"
              />    
          </div> 
          // : roles[0] == USERTYPES.ADMIN ? 
          //     <div className='hosp-div'>
          //         <label className='label'>{t("upload-study.choose-firm")}</label>
          //         <Dropdown
          //         // styles={dropDownStyle}
          //         options ={props.hospOrFirmList}             
          //         onChange={ props.handleHospital } 
          //         className="firm-dropdown"
          //         />  
          //     </div> : null
      }
       {(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST ) && 
        <div style={{marginBottom:"20px"}}>
            <div style={{color: getThemeColor("primary-color")}} className="upload-study-body-label">{t("upload-study.firm")}<span style={{ marginLeft: "4px", color: 'red' }}>*</span></div>
            <CustomSelect
              options={props.firmOption}
              defaultValue={
                props.filterObj.firmId
                ? props.firmOption.find(option => option.value === props.filterObj.firmId)
                : props.firmOption.length == 0 ? props.firmOption[0] : -1}
              value={
                props.filterObj.firmId
                ? props.firmOption.find(option => option.value === props.filterObj.firmId)
                : props.firmOption.length == 0 ? props.firmOption[0] : -1}

              label={t("upload-study.firm")}
              placeholder={t("upload-study.select-firm")} 
              maxHeight="30px"
              errorState={props.errorState}
              onChange={(item) => {
                props.handleDicomFirmChange(item);
              }}
              zIndex={1000}
            />
            <div style={{ marginLeft:"10px", marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>
                {props.dicomFirmDropDownError}
            </div>
          </div>
        }
        
        {props.showDicomClientOption && <div>
          <div style={{color: getThemeColor("primary-color")}} className="upload-study-body-label">{t("upload-study.client")}
           {!(roles[0] == USERTYPES.ADMIN || roles[0] == USERTYPES.RADIOLOGIST) && <span style={{ marginLeft: "4px", color: 'red' }}>*</span>}
          </div>
          <CustomSelect
            options={props.clientOptions}
            defaultValue={
              props.filterObj.minimalClientId
              ? props.clientOptions.find(option => option.value === props.filterObj.minimalClientId)
              : props.clientOptions.length == 0 ? props.clientOptions[0] : -1}
            value={
              props.filterObj.minimalClientId
              ? props.clientOptions.find(option => option.value === props.filterObj.minimalClientId)
              : props.clientOptions.length == 0 ? props.clientOptions[0] : -1}

            label={t("upload-study.client")}
            placeholder={t("upload-study.select-client")} 
            maxHeight="30px"
            errorState={props.errorState}
            onChange={(item) => {
              props.handleClientChange(item);
            }}
            zIndex={999}
          />
          <div style={{ marginLeft:"10px", marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>
                {props.dicomClientDropDownError}
            </div>
        </div>}

      <div className='upload-study' style={{ marginTop: "40px", paddingLeft: "8px",paddingRight: "8px"  }}>
      {!props.isUploadAllowed && <div style={{color: "red", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>{props.errorMessage}</div>}
          <FileUploader handleChange={handleUploadFile} name="files" types={props.fileTypes} classes="label-class"
          label="Drag your file(s) here or browse" multiple={true} children={<p className='fileUploader' style={{color:getThemeColor("primary-color")}}>
            {t("upload-study.drag-drop-files")}</p>}
          />
         {props.showDicomErrorMessage && <div style={{ marginTop:"10px", color: "red",fontWeight:"700", fontSize: "12px", lineHeight:"16px", marginBottom: "5px"}}>{props.dicomErrorMessage}</div>}
      </div>
      <div className={`studyFileNamesContainer  ${getScrollBarStyleForTheme(themeName,"common-modal-scroll")}`} style={{ paddingLeft: "8px",paddingRight: "8px"  }}>
      {/* {props.uploadFiles.map((file, index) => (
            <div key={index}>{file}</div>
        ))} */}
        {progressObjs.map((progressObj, index) => (
        !progressObj.isJpg && (
        <div key={index} className="fileNamesContent">
          <ProgressBar
            progressBarId={index}
            setSelectedFileName={progressObj.setSelectedFileName}
            setValues={progressObj.setValues}
            formData={progressObj.formData}
            height={progressObj.height}
            fileName={progressObj.fileName}
            isZip={progressObj.isZip}
            isJpg = {progressObj.isJpg}
          />
        </div>)
        ))}
      </div>
    </div>
    )
};